import Vue from 'vue';
import DialogNotify from '@/components/DialogNotify.vue';

const DialogConstructor = Vue.extend(DialogNotify);

const dialogPlugin = {
  install(Vue) {
    const instance = new DialogConstructor();
    instance.$mount(document.createElement('div'));
    document.body.appendChild(instance.$el);

    Vue.prototype.$dialogNotify = instance;
  },
};

export default dialogPlugin;
